/* eslint-disable import/no-extraneous-dependencies */
import { WithStyles } from '@mui/styles';
import { AccountWithdrawalDataRecord, FirmRecord, WithdrawalTypeEnumMap } from '@tassat/fred-definitions';
import { ActionTypes, SelectOption } from '@tassat/ui-definitions';
import { FormikProps } from 'formik';

import muiStyles from './styles';

export interface WithdrawalFormProps {
    actionType: ActionTypes;
    editWithdrawalInstruction: AccountWithdrawalDataRecord;
    firmWithdrawalInstructions: Array<AccountWithdrawalDataRecord>;
    submitWithdrawalForm: (
        values: IFormValues,
        opts: {
            actionType: ActionTypes;
            onClose?: () => void;
            setSubmitError: React.Dispatch<React.SetStateAction<string>>;
            editWithdrawalInstruction: AccountWithdrawalDataRecord;
            firmId: string;
        }
    ) => any;
    firm: FirmRecord;
    bankAccountTypes: SelectOption[];
    deleteWithdrawalInstruction?: (instruction) => void;
    arePendingTransactions?: (instructionId: string) => Promise<boolean>;
}

export interface IFormikProps extends WithStyles<typeof muiStyles> {
    onClose: () => void;
    formProps: WithdrawalFormProps;
}

export interface IFormProps extends IFormikProps, FormikProps<IFormValues> {
    submitError: string;
    actionType: ActionTypes;
    editWithdrawalInstruction?: AccountWithdrawalDataRecord;
    validatingWithdrawalDescription?: boolean;
    setWithdrawalDescriptionValidated?: React.Dispatch<React.SetStateAction<boolean>>;
    deleteWithdrawalInstruction?: (instruction) => void;
    onClose: () => void;
}

export interface IFormValues {
    Description: string;
    WithdrawalType: SelectOption;
    BeneName: string;
    BeneBankAcct: string;
    BeneStreetAddress: string;
    BeneCity: string;
    BeneStateProv: SelectOption | string;
    BenePostalCode: string;
    BeneCountry: string;
    BeneBankName: string;
    BeneBankAccountType: SelectOption;
    BeneBankRoutNum: string;
    BeneBankBic: string;
    BeneBankStreetAddress: string;
    BeneBankCity: string;
    BeneBankStateProv: SelectOption | string;
    BeneBankPostalCode: string;
    BeneBankCountry: string;
    IntermediaryBankName: string;
    IntermediaryBankRoutNum: string;
    IntermediaryBankBic: string;
    IntermediaryBankStreetAddress: string;
    IntermediaryBankCity: string;
    IntermediaryBankStateProv: SelectOption | string;
    IntermediaryBankPostalCode: string;
    IntermediaryBankCountry: string;
    BeneInfo1: string;
    BeneInfo2: string;
    BeneInfo3: string;
    BeneInfo4: string;
    BankToBankInfo1: string;
    BankToBankInfo2: string;
    BankToBankInfo3: string;
    BankToBankInfo4: string;
    Blockchain: SelectOption;
    Address: string;
}

export type IErrors = Record<keyof IFormValues, string>;

export const withdrawalInstructionTypes: SelectOption[] = Object.values(WithdrawalTypeEnumMap)
    .map((withdrawalType) => ({
        label: withdrawalType.displayValue,
        value: withdrawalType.value
    }));

export const bankAccountTypes: SelectOption[] = [
    {
        label: 'Checking',
        value: 'Checking'
    },
    {
        label: 'Savings',
        value: 'Savings'
    }
];

// INFO: Core does not generate a type for this list (see FRED-6697) - keep in sync with
// the `Blockchain` field's validValues in FREDMessages.xml if the supported chains change.
export const blockchainTypes: SelectOption[] = [
    {
        label: 'Ethereum',
        value: 'Ethereum'
    },
    {
        label: 'Avalanche',
        value: 'Avalanche'
    },
    {
        label: 'Solana',
        value: 'Solana'
    }
];